import ModalEditRow from './ModalEditRow-compose';

export default ModalEditRow;
